/** @typedef {"motionAir" | "rentman"} SyncTarget */

export const STALE_SYNC_MS = 3 * 60 * 1000;

/**
 * @param {object|null|undefined} progress
 * @return {boolean}
 */
export function isStaleSyncProgress(progress) {
  if (!progress || progress.status !== "in_progress") {
    return false;
  }
  if (progress.lastUpdated) {
    return Date.now() - new Date(progress.lastUpdated).getTime() > STALE_SYNC_MS;
  }
  return progress.phase === "syncing" || progress.phase === "linking";
}

/**
 * @param {object|null|undefined} userSettings
 * @return {{ progress: object, label: string }|null}
 */
export function getActiveSyncProgress(userSettings) {
  const motionAir =
    userSettings?.motionAirSyncProgress || userSettings?.syncProgress;
  const rentman = userSettings?.rentmanSyncProgress;

  const candidates = [
    motionAir?.status === "in_progress" && !isStaleSyncProgress(motionAir)
      ? { progress: motionAir, label: "Motion Air" }
      : null,
    rentman?.status === "in_progress" && !isStaleSyncProgress(rentman)
      ? { progress: rentman, label: "Rentman" }
      : null,
  ].filter(Boolean);

  return candidates[0] || null;
}

/**
 * @param {object|null|undefined} summary
 * @return {string|null}
 */
export function formatSyncSummary(summary) {
  if (!summary) return null;
  const parts = [];
  if (summary.synced != null) parts.push(`${summary.synced} synced`);
  if (summary.skipped) parts.push(`${summary.skipped} skipped`);
  if (summary.failed) parts.push(`${summary.failed} failed`);
  return parts.length ? parts.join(" · ") : null;
}

/**
 * @param {object|null|undefined} userSettings
 * @return {boolean}
 */
export function hasStaleSync(userSettings) {
  const motionAir =
    userSettings?.motionAirSyncProgress || userSettings?.syncProgress;
  const rentman = userSettings?.rentmanSyncProgress;
  return (
    isStaleSyncProgress(motionAir) ||
    isStaleSyncProgress(rentman) ||
    (!!userSettings?.isSyncing &&
      !getActiveSyncProgress(userSettings))
  );
}
